<template>
    <div class="v-main">
        
        <div class="leftBlock">
            <leftBlock />
        </div>
        <div class="rightBlock">
            <rightBlock />
        </div>

    </div>
</template>

<script>
import leftBlock from "../leftBlock/v-leftBlock"
import rightBlock from "../rigthBlock/v-rightBlock"

export default {
    name: "v-main",
    components : {
        leftBlock,
        rightBlock
    }
}
</script>

<style lang="scss">
.v-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    .leftBlock {
        width: 15%;
    }
    .rightBlock {
        width: 85%;
        
    }
}

@media (max-width : 900px) and (min-width: 534px){
    .v-main{
        display: flex;
        flex-direction: row;
        .leftBlock{
            width: 30%;
        }
        .rightBlock{
            width: 70%;
        }
    }
}

@media (max-width : 534px) and (min-width: 230px){
    .v-main{
        display: flex;
        flex-direction: column;
        .leftBlock{
            width: 50%;
        }
        .rightBlock{
            width: 100%;
        }
    }
}
</style>